import { Helmet } from "react-helmet-async";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export default function Boost() {
  return (
    <main className="mx-auto w-full max-w-5xl px-4 py-8 space-y-6">
      <Helmet>
        <title>Boosts | FANZ</title>
        <meta name="description" content="Boost tiers: featured, spotlight, pinned placements." />
        <link rel="canonical" href={typeof window !== 'undefined' ? window.location.href : 'https://example.com/boost'} />
      </Helmet>
      <header>
        <h1 className="text-2xl font-semibold">Boost your visibility</h1>
        <p className="text-sm text-muted-foreground mt-1">Choose a placement tier and schedule.</p>
      </header>
      <section className="grid gap-4 md:grid-cols-3">
        {[
          { title: "Featured Row", desc: "Top of search grid" },
          { title: "Spotlight", desc: "Hero-below marquee" },
          { title: "Pinned Card", desc: "First screen pin" },
        ].map((t) => (
          <Card key={t.title}>
            <CardHeader><CardTitle>{t.title}</CardTitle></CardHeader>
            <CardContent className="text-sm text-muted-foreground">{t.desc}</CardContent>
          </Card>
        ))}
      </section>
    </main>
  );
}
